import {
  FETCH_SALES_COACHING_COUNT_REQUEST,
  FETCH_SALES_COACHING_COUNT_SUCCESS,
  FETCH_SALES_COACHING_COUNT_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  get: {
    count: 0,
    error: null,
    isFetching: false,
  },
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_SALES_COACHING_COUNT_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      }

    case FETCH_SALES_COACHING_COUNT_SUCCESS:
      return {
        ...state,
        get: {
          ...state.get,
          count: action.payload,
          isFetching: false,
          error: null,
        },
      }

    case FETCH_SALES_COACHING_COUNT_ERROR:
      return {
        ...state,
        get: {
          ...state.get,
          count: 0,
          isFetching: false,
          error: action.payload,
        },
      }

    default:
      return state
  }
}

export default record
